<script setup>
import { useRouter } from 'vue-router'
import AgentItemCard from '@/components/agents/AgentItemCard.vue'

const emit = defineEmits(['start', 'stop', 'show-qr', 'upload-chats', 'show-code', 'refresh', 'reload'])

const props = defineProps({
  items: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  maxPhoneNumberChanges: { type: Number, default: 0 },
})

const router = useRouter()

const goToDetail = (item) => {
  router.push({
    query: { edit: item.id }
  })
}
</script>

<template>
  <div>
    <div class="q-gutter-y-md">
      <AgentItemCard
        v-for="item in props.items"
        :key="item.id"
        :item="item"
        :max-phone-number-changes="props.maxPhoneNumberChanges"
        @stop="emit('stop', item)"
        @start="emit('start', item)"
        @show-qr="emit('show-qr', item)"
        @detail="goToDetail(item)"
        @upload-chats="emit('upload-chats', item)"
        @show-code="emit('show-code', item)"
        @refresh="emit('refresh', item)"
        @reload="emit('reload')"
      />

      <q-card
        v-if="!props.loading && (!props.items || props.items.length === 0)"
        class="text-center q-pa-lg bg-grey-1 dashed-border"
      >
        <q-card-section>
          <div class="text-grey-6">
            {{ $t('agents.list.empty') }}
          </div>
        </q-card-section>
      </q-card>
    </div>

    <q-inner-loading :showing="props.loading">
      <q-spinner
        color="primary"
        size="2em"
      />
    </q-inner-loading>
  </div>
</template>

